module.exports = __webpack_public_path__ + "img/icons-40-perks-testing-fun.8619848f.svg";